export default {
    person: {
        wzTZ: 'KingGloryBackgroundManagementSystemNotice',
        wzKF: 'DeveloperContactInformation',
        QQ1: 'QQNo.1',
        QQ2: 'QQNo.2',
        mailbox: 'mailbox',
        browser: 'browser',
        RecommendedUse: 'RecommendedUse',
        mattersNeedingAttention: 'mattersNeedingAttention',
        mattersNeedingAttention1: 'ProhibitModificationOnTheOriginalBasisAndUseForCommercialPurposes',
        mattersNeedingAttention2: 'ForDevelopers,ThisPageIsOnlyUsedForCommunicationAndLearning',
        version: 'version',
    },
    home:{
        wzry:"Login",
        game:'Login',
        account:'PleaseEnterAnAccountNumber',
        password:'PleaseInputAPassword',
        remember:'RememberPassword'
    },
    Login:{
        name:"Welcome",
        register:"Register",
        logon:"Login",
        ZY:"Guofu Dianwei Ledfei",
        ReSelect:"ReSelect"
    }
};